import { createContext } from 'react';

export interface CampusFeatureFlags {
  // hasEv: boolean;
  hasBattery: boolean;
  // hasThermalZones: boolean;
  // hasSolar: boolean;
  // hasSingleGX: boolean;
}

export interface CampusContextType {
  featureFlags: CampusFeatureFlags;
}

const defaultFeatureFlags: CampusFeatureFlags = {
  hasBattery: false,
};

export const defaultCampusContext: CampusContextType = {
  featureFlags: defaultFeatureFlags,
};

export const CampusContext = createContext<CampusContextType | undefined>(undefined);
